import VideoUploadItemComponent from "./VideoUploadItemComponent";

export default VideoUploadItemComponent;